var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 13,
    viewBox: "0 0 8 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.05609 11.4771C1.97431 11.4771 1.90275 11.4396 1.84142 11.3644C1.71875 11.2141 1.71875 10.9762 1.84142 10.8384L5.49078 6.36758L1.81075 1.85915C1.68808 1.70887 1.68808 1.47093 1.81075 1.33317C1.93342 1.18289 2.12764 1.18289 2.24009 1.33317L6.34945 6.36758L2.28098 11.3644C2.21964 11.4396 2.13786 11.4771 2.05609 11.4771Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.32fe710ead5f4a3bed2bafadd7c91c1b.svg";
export { ForwardRef as ReactComponent };